import {RoleBasedPermission, type Permission, type PermissionType} from '@hconnect/apiclient'

// Mirrors the permissions accepted by pom-questionnaires `actions/bulk-upload` (any of them)
const BULK_UPLOAD_PLANT_ACTIONS_PERMISSIONS: PermissionType[] = [
  'CHANGE_POM_DASHBOARD',
  RoleBasedPermission.HproduceRoleCCCSupporter,
  RoleBasedPermission.HproduceRoleERPUser,
  RoleBasedPermission.HproduceRoleMaintenanceManager,
  RoleBasedPermission.HproduceRolePlantAdministrator,
  RoleBasedPermission.HproduceRolePlantController,
  RoleBasedPermission.HproduceRoleProductionManager,
  RoleBasedPermission.HproduceRoleQualityManager,
  RoleBasedPermission.HproduceRoleUserManager
]

export const hasCreateTaskPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'CREATE_PROCESS_WORK_ORDER')

export const hasBulkUploadPlantActionsPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => BULK_UPLOAD_PLANT_ACTIONS_PERMISSIONS.includes(p.permissionType))
